import { useEffect } from 'react';

export function useEventTracker(eventTracker, ref) {
  useEffect(() => {
    const htmlElement = ref.current;
    const events = eventTracker.eventsList;
    const listener = (event) => {
      eventTracker.track(event);
    };

    events.forEach((event) => {
      htmlElement.addEventListener(event, listener);
    });

    return () => {
      events.forEach((event) => {
        htmlElement.removeEventListener(event, listener);
      });
    };
  }, []);
}
